import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { changeTitle } from "./../../modules/navigation";
import { push } from "react-router-redux";
import Grid from "material-ui/Grid";
import Paper from "material-ui/Paper";

import FuelLogo from "./../../images/fuel-logo.png";
import DrivingLogo from "./../../images/driving-logo.png";
import ScanLogo from "../../images/scan-logo.png";
import GasLogo from "../../images/gas-logo.png";
import TempLogo from "../../images/temp-logo.png";
import DashboardLogo from "./../../images/dashboard-logo.svg";
import "./Home.css";

class Home extends React.Component {
  componentDidMount() {
    this.props.changeTitle("Zeek Apps");
  }

  render() {
    return (
      <div className="home">
        <TemporalHome {...this.props} />
      </div>
    );
  }
}

const TemporalHome = props => {
  return (
    <div className="root">
      <Grid container className="grid-container">
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <Paper
            className={`menu-card ${
              props.permissions.Dashboard === true ? "active" : "inactive"
            }`}
            onClick={
              props.permissions.Dashboard === true
                ? props.changePage.bind(this, "./dashboard")
                : () => {}
            }
          >
            <img src={DashboardLogo} alt="temp" className="card-image" />
          </Paper>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <Paper
            className={`menu-card ${
              props.permissions.Driving === true ? "active" : "inactive"
            }`}
            onClick={
              props.permissions.Driving === true
                ? props.changePage.bind(this, "./driving")
                : () => {}
            }
          >
            <img src={DrivingLogo} alt="driving" className="card-image" />
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <Paper
            className={`menu-card ${
              props.permissions.Fuel === true ? "active" : "inactive"
            }`}
            onClick={
              props.permissions.Fuel === true
                ? props.changePage.bind(this, "./fuel")
                : () => {}
            }
          >
            <img src={FuelLogo} alt="fuel" className="card-image" />
          </Paper>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <Paper
            className={`menu-card ${
              props.permissions.ConsultaTemp === true ? "active" : "inactive"
            }`}
            onClick={
              props.permissions.ConsultaTemp === true
                ? props.changePage.bind(this, "./temp")
                : () => {}
            }
          >
            <img src={TempLogo} alt="temp" className="card-image" />
          </Paper>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <Paper
            className={`menu-card ${
              props.permissions.Gas === true ? "active" : "inactive"
            }`}
            onClick={
              props.permissions.Gas === true
                ? props.changePage.bind(this, "./gas")
                : () => {}
            }
          >
            <img src={GasLogo} alt="gas" className="card-image" />
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          <Paper
            className={`menu-card ${
              props.permissions.ConsultaCan === true ? "active" : "inactive"
            }`}
            onClick={
              props.permissions.ConsultaCan === true
                ? props.changePage.bind(this, "./scan")
                : () => {}
            }
          >
            <img src={ScanLogo} alt="scan" className="card-image" />
          </Paper>
          {/* <Paper className={`menu-card inactive`}>
            <img src={ScanLogo} alt="scan" className="card-image" />
          </Paper> */}
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = state => ({
  lang: state.internationalization.lang,
  permissions: state.permissions.data
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: page => push(page),
      changeTitle
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js